import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { OpenComponentLinkModule } from '@signature-it/ngx-generic/directives';
import { GroupsMenuComponentGeneric } from './groups-menu.component';

@NgModule({
    declarations: [
        GroupsMenuComponentGeneric
    ],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        OpenComponentLinkModule
    ],
    exports: [GroupsMenuComponentGeneric]
})
export class GroupsMenuModuleGeneric { }
